import React from 'react';
import { Redirect } from 'react-router-dom';
import { useLocation } from 'react-router-dom';
import {
  getUKCountry,
  UK_COUNTRY_TO_VANITY,
} from '../../services/signup-service';
import CountrySelector from './country-selector.component';

const CreateAccountPreFlow: React.FC = () => {
  const { search } = useLocation();
  const params = new URLSearchParams(search);
  const redirectUrl = params.get('redirect_url') ?? '';
  const qs = redirectUrl
    ? `?redirect_url=${encodeURIComponent(redirectUrl)}`
    : '';

  const existingCountry = getUKCountry();
  if (existingCountry && UK_COUNTRY_TO_VANITY[existingCountry]) {
    return (
      <Redirect to={`/sleepio/${UK_COUNTRY_TO_VANITY[existingCountry]}${qs}`} />
    );
  }

  return <CountrySelector redirectUrl={redirectUrl} />;
};

export default CreateAccountPreFlow;
